import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { cn } from '@workspace/ui/lib/utils';

import { company } from '~/company/Company';
import CommonCarousel from '~/components/CommonCarousel/CommonCarousel';
import { useCategoryAnalytics } from '~/hooks/useCategoryAnalytics';
import { useGlobal } from '~/hooks/useGlobal';
import type { Category } from '~/stores/CategoriesStore';

import CategoryBlockTitle from '../CategoryBlockTitle';
import { cfSrcForImage, createCategoryUrl } from '../utils';
import styles from './CategoriesCarouselSquareThreeWBlock.module.scss';

interface CategoriesCarouselSliderThreeWBlockProps {
  category: Category;
}

const CategoriesCarouselSliderThreeWBlock = ({
  category,
}: CategoriesCarouselSliderThreeWBlockProps) => {
  const { isMobile } = useGlobal();
  const { handleClickCategory } = useCategoryAnalytics();

  if (!category.subcategory.length || !category.subcategory[0]?.id) {
    return null;
  }

  return (
    <div
      className={cn(
        styles.container,
        company.match({
          mcosmetic: undefined,
          default: 'lg:mx-auto lg:max-w-[1280px] lg:px-10',
        }),
      )}
    >
      <CategoryBlockTitle
        text={category.name}
        className={company.match({
          mcosmetic: undefined,
          default: 'ms-4 me-4 lg:ms-0 lg:me-0',
        })}
        categoryId={category.id}
      />
      <CommonCarousel
        sliderClassName="w-full"
        slideClassName="basis-[120px]! pl-0!"
        spaceBetween={isMobile ? 12 : 20}
        slidesPerViewProp="auto"
        pagination={{
          enabled: true,
        }}
      >
        {category.subcategory.map(({ name, previewImage, id, previewText }) => (
          <Link
            key={id}
            data-link={`category-${id}`}
            onClick={handleClickCategory(id)}
            to={createCategoryUrl({ id })}
          >
            <div className="bg-contain">
              {previewImage ? (
                <img
                  src={cfSrcForImage(previewImage, {
                    width: 285,
                    height: 380,
                  })}
                  alt=""
                  className="size-[120px] rounded-3 border-0 align-middle"
                />
              ) : (
                <div className="size-[120px] rounded-3 border-0 align-middle" />
              )}
              <div
                className={cn(
                  'mt-3 mb-[3px] line-clamp-3 text-center text-(--text900Prim) [font:var(--headingH3)]',
                  company.match({
                    mcosmetic: 'max-md:[font:var(--text-100-medium)]',
                  }),
                )}
              >
                {previewText || name}
              </div>
            </div>
          </Link>
        ))}
      </CommonCarousel>
    </div>
  );
};

export default observer(CategoriesCarouselSliderThreeWBlock);
